module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 's62h0fiv',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
